import { Navigate, Outlet } from 'react-router-dom'
import { CustomLoader } from '@/components/atoms/CustomLoader'
import { useAuth } from '@/contexts/AuthContext'
import { getToken } from '@/services/token'

export default function PrivateLayout() {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return <CustomLoader />
  }
  const token = getToken()
  if (!loading && !isAuthenticated && !token) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
